(function () {
  'use strict';
  const selector = '#globo-formbuilder-163971, #globo-formbuilder-161961, #globo-formbuilder-167195';
  const attempts = new WeakMap();
  function visibleSuccess(root) {
    return Array.from(root.querySelectorAll('.message.success')).some(function (message) {
      return message.getClientRects().length > 0 && getComputedStyle(message).visibility !== 'hidden';
    });
  }
  function status(root, value) { root.setAttribute('data-sm-repair-tracking', value); }
  function arm(event) {
    if (!event.isTrusted || !event.target || typeof event.target.closest !== 'function') return;
    const root = event.target.closest(selector);
    if (!root) return;
    if (event.type === 'click') {
      const control = event.target.closest('button, input');
      if (!control || control.type !== 'submit') return;
    }
    if (visibleSuccess(root)) return;
    let attempt = attempts.get(root);
    if (!attempt) {
      attempt = {armed: false, sent: false};
      attempts.set(root, attempt);
      const observer = new MutationObserver(function () {
        if (!attempt.armed || attempt.sent || !visibleSuccess(root)) return;
        attempt.armed = false;
        const privacy = window.Shopify && Shopify.customerPrivacy;
        if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') {
          status(root, 'privacy-api-unavailable'); return;
        }
        if (privacy.analyticsProcessingAllowed() !== true) {
          status(root, 'analytics-consent-denied'); return;
        }
        const leads = window.ShoeMedicLeadAnalytics;
        if (!leads || typeof leads.formSuccess !== 'function') {
          status(root, 'lead-sender-unavailable'); return;
        }
        const result = leads.formSuccess(root.id.replace('globo-formbuilder-', ''));
        attempt.sent = result === 'queued';
        status(root, result);
      });
      observer.observe(root, {childList: true, subtree: true, attributes: true,
        attributeFilter: ['class', 'style', 'hidden']});
    }
    attempt.armed = true;
    attempt.sent = false;
    status(root, 'armed');
  }
  document.addEventListener('click', arm, true);
  document.addEventListener('submit', arm, true);
  if (window.Shopify && typeof Shopify.loadFeatures === 'function' && !Shopify.customerPrivacy) {
    Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], function () {});
  }
}());
